import type { LabelledAnatomySpec } from './labelled-anatomy.js';

/**
 * The Earth in radial section, at true radial scale. Inner core to 1221 km,
 * outer core to 3480 km, mantle to about 6336 km, crust to the mean radius of
 * 6371 km. The crust is the point of the figure: 35 km of a 6371 km radius is
 * less than one pixel on a phone, and the compiler refuses to fatten it.
 */
export function labelledAnatomyFixture(width = 640, focusShellId = 'crust'): LabelledAnatomySpec {
  return {
    id: 'earth-interior-section',
    family: 'labelled-anatomy',
    view: 'section',
    viewport: { width, height: 470 },
    subject: 'Earth interior',
    unit: 'km',
    shells: [
      { id: 'inner-core', label: 'Inner core', outer: 1221, detail: 'iron and nickel', state: 'solid' },
      { id: 'outer-core', label: 'Outer core', outer: 3480, detail: 'convects, makes the field', state: 'liquid' },
      { id: 'mantle', label: 'Mantle', outer: 6336, detail: 'silicate rock', state: 'solid, creeping' },
      { id: 'crust', label: 'Crust', outer: 6371, detail: 'everything we live on', state: 'solid' },
    ],
    cutNote: 'The flat face is the cut · every boundary is at its measured depth',
    focusShellId,
    title: 'Everything we live on is the thinnest line here',
    subtitle: 'One scale factor governs every boundary, so the crust cannot be drawn thicker than the truth allows.',
    provenance: 'Preliminary Reference Earth Model boundary depths; mean Earth radius 6371 km',
  };
}
